<template>
  <div class="container">
    <div class="container-inner">
      <h1>Guide</h1>
      <hr>
      <TheSvgList class="guide-svg" style="display: flex"/>
      <hr>
      <div class="guide-block">
        <pre>.modal</pre>

        <button type="button" class="base-btn base-btn--blue-dark" @click="$vModal.open('take-to-work')">
          <span class="base-btn__text">take-to-work</span>
        </button>

        <button type="button" class="base-btn base-btn--blue-dark" @click="$vModal.open('reject-candidate')">
          <span class="base-btn__text">reject-candidate</span>
        </button>
      </div>
      <hr>
      <div class="guide-block">
        <pre>.base-btn</pre>

        <button type="button" class="base-btn base-btn--blue-dark">
          <span class="base-btn__text">base-btn--blue-dark</span>
        </button>

        <button type="button" class="base-btn base-btn--blue">
          <span class="base-btn__text">base-btn--blue</span>
        </button>

        <button type="button" class="base-btn base-btn--green">
          <span class="base-btn__text">base-btn--green</span>
        </button>

        <button type="button" class="base-btn base-btn--grey-blue">
          <span class="base-btn__text">base-btn--grey-blue</span>
        </button>
        <button type="button" class="base-btn base-btn--gray-green">
          <span class="base-btn__text">base-btn--gray-green</span>
        </button>

        <button type="button" class="base-btn base-btn--white">
          <span class="base-btn__text">base-btn--white</span>
        </button>

        <button type="button" class="base-btn base-btn--outline-green">
          <span class="base-btn__text">base-btn--outline-green</span>
        </button>

        <button type="button" class="base-btn base-btn--outline-grey">
          <span class="base-btn__text">base-btn--outline-grey</span>
        </button>

        <button type="button" class="base-btn base-btn--outline-blue">
          <BaseSvg name="ico-tick" width="1.5rem" height="1.1rem"/>
          <span class="base-btn__text">base-btn--outline-blue</span>
        </button>

        <button type="button" class="base-btn base-btn--outline-orange">
          <BaseSvg name="ico-tick" width="1.5rem" height="1.1rem"/>
          <span class="base-btn__text">base-btn--outline-orange</span>
        </button>

        <button type="button" class="base-btn base-btn--outline-grey  base-btn--hover-blue">
          <span class="base-btn__text">base-btn--outline-grey base-btn--hover-blue</span>
        </button>

        <button type="button" class="base-btn base-btn--outline-grey-green">
          <span class="base-btn__text">base-btn--outline-grey-green</span>
          <BaseSvg name="ico-logout" width="1.5rem" height="1.1rem"/>
        </button>

        <button type="button" class="base-btn  base-btn--outline-grey  base-btn--small">
          <span class="base-btn__text">base-btn--outline-grey base-btn--small</span>
          <span class="base-btn__text">base-btn--outline-grey
            base-btn--small base-btn--outline-grey-green</span>
          <BaseSvg name="ico-logout" width="1.5rem" height="1.1rem"/>
        </button>

        <button type="button" class="base-btn  base-btn--outline-grey  base-btn--small">
          <BaseSvg name="ico-plus" width="1.2rem" height="1.2rem"/>
          <span class="base-btn__text">base-btn--outline-grey base-btn--small</span>
        </button>

        <button type="button" class="base-btn  base-btn base-btn--outline-grey--blue  base-btn--small">
          <span class="base-btn__text">base-btn--small base-btn base-btn--outline-grey--blue</span>
        </button>

        <button type="button" class="base-btn  base-btn base-btn--outline-grey--green  base-btn--small">
          <span class="base-btn__text">base-btn--small base-btn base-btn--outline-grey--green</span>
        </button>
      </div>
      <hr>
      <div class="guide-block">
        <pre>.inline-link</pre>

        <a href="#" class="inline-link">
          <span>Все вакансии компании (99)</span>&nbsp;<BaseSvg
                name="ico-arrow-light"
                class="_arrow"/>
        </a>
        <br>
        <br>
        <a href="#" class="inline-link _dotted">
          <span>Все вакансии компании (99)</span>&nbsp;<BaseSvg
                name="ico-arrow-light"
                class="_arrow"/>
        </a>
      </div>
      <hr>
      <div class="guide-block">
        <pre>.text</pre>

        <div class="text" style="max-width: 450px; background: white; padding: 30px;">
          <h1>h1 Title Lorem ipsum dolor.</h1>
          <h2>h2 Title Lorem ipsum dolor.</h2>
          <h3>h3 Title Lorem ipsum dolor sit amet, consectetur.</h3>
          <h4>h4 Title Lorem ipsum dolor sit amet, consectetur.</h4>
          <h5>h5 Title Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequatur,
            ipsum.</h5>
          <h6>h6 Title Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iure, numquam!</h6>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab harum labore, laudantium
            magnam nihil nobis provident quasi qui suscipit voluptas.</p>
          <h1>h1 Title</h1>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aut numquam quas rerum!</p>
          <h2>h2 Title</h2>
          <p>Rem sed, tempore. Ad, aliquid at cumque error incidunt iure quia repellendus?</p>
          <h3>h3 Title</h3>
          <p>Assumenda, autem consectetur distinctio eaque eligendi hic impedit inventore laborum
            quis voluptas.</p>
          <h4>h4 Title</h4>
          <p>Aliquam, amet delectus dolor error modi neque omnis quaerat quibusdam vitae.
            Debitis!</p>
          <h5>h5 Title</h5>
          <p>Distinctio error explicabo facere incidunt laborum, quia soluta tenetur. Sint, ullam,
            velit?</p>
          <h6>h6 Title</h6>
          <p>Adipisci amet asperiores aspernatur ducimus ipsum nisi non officiis omnis possimus
            provident.</p>

          <ul>
            <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Architecto.</li>
            <li>Debitis eum labore minus obcaecati ratione sint ut voluptatum.</li>
            <li>Consequuntur cupiditate enim iusto necessitatibus numquam obcaecati perferendis
              temporibus.
            </li>
          </ul>
          <ol>
            <li>Lorem ipsum dolor sit amet, consectetur.</li>
            <li>Consequatur molestias nam quis quod soluta!</li>
            <li>Aliquid commodi cum dolor enim omnis!</li>
          </ol>

          <table>
            <thead>
            <tr>
              <td>title 1</td>
              <td>title 2</td>
              <td>title 3</td>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>some text</td>
              <td>some text 2</td>
              <td>some text 3</td>
            </tr>
            <tr>
              <td>some text</td>
              <td>some text 2</td>
              <td>some text 3</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <hr>
      <div class="guide-block">
        <pre>base-link</pre>

        <a href="#" class="base-link">
          <BaseSvg name="ico-question"
                   width="1.5rem"
                   height="1.5rem"
                   class="base-link__ico"
          />
          <span class="base-link__text">Как работает сервис</span>
        </a>
      </div>
      <hr>
      <hr>
      <div class="guide-block">
        <pre>base-svg</pre>

        <BaseSvg name="ico-arrow" width="2rem" height="2rem"/>
      </div>
      <hr>
      <div class="guide-block" style="max-width: 450px; background: white; padding: 30px;">
        <pre>base-input</pre>

        <div style="display: flex; margin: 20px 0">
          <BaseInput v-model="inputValue"
                     label="Some input"
                     required
                     style="width: 200px"/>
          | {{inputValue}}
        </div>

        <div style="display: flex; align-items: flex-start">
          <BaseInput v-model="inputValue"
                     label="Some input"
                     :error="isInputError ? 'Input error' : null"
                     style="width: 200px; margin-right: 10px"/>
          <BaseCheckbox v-model="isInputError"
                        label="Show input error?"
                        required/>
        </div>

        <div style="display: flex; align-items: flex-start">
          <BaseInput v-model="inputValueNumber"
                     type="number"
                     label="Number"
                     style="width: 200px; margin-right: 10px"/>
          {{inputValueNumber}}
        </div>

        <div style="display: flex; align-items: flex-start">
          <BaseInput v-model="inputValueTime"
                     mask="##"
                     label="Time"
                     style="width: 200px; margin-right: 10px"/>
          {{inputValueTime}}
        </div>
      </div>
      <hr>
      <div class="guide-block" style="max-width: 450px; background: white; padding: 30px;">
        <pre>base-radio-list</pre>

        <div style="display: flex; margin: 20px 0">
          <BaseRadioList v-model="inputValue"
                         label="Some input"
                         required
                         style="width: 200px"/>
          | {{inputValue}}
        </div>

        <div style="display: flex; align-items: flex-start">
          <BaseRadioList v-model="radioListValue"
                         :options="radioList"
                         style="width: 200px; margin-right: 10px"/>
          | {{radioListValue}}
        </div>
        <hr>
        <div style="display: flex; align-items: flex-start">
          <BaseRadioList v-model="radioListValue2"
                         :options="radioList"
                         style="width: 200px; margin-right: 10px"
                         class="_vertical"/>
          | {{radioListValue2}}
        </div>

      </div>
      <hr>
      <div class="guide-block" style="max-width: 450px; background: white; padding: 30px;">
        <pre>base-select</pre>

        <div style="display: flex; margin: 20px 0">
          <BaseSelect v-model="selectValue"
                      :options="selectList"
                      label="Some select"
                      required
                      style="width: 200px"/>
          | {{selectValue}}
        </div>

        <div style="display: flex; margin: 20px 0; padding: 20px; background-color: #506c85">
          <BaseSelect v-model="selectValue"
                      :options="selectList"
                      label="Some select"
                      required
                      class="_white"
                      style="width: 200px"/>
          | {{selectValue}}
        </div>

        <div style="display: flex; margin: 20px 0">
          <BaseSelect v-model="selectValue"
                      :options="selectList"
                      label="Some select"
                      required
                      class="_shadow"
                      style="width: 200px"/>
          | {{selectValue}}
        </div>

      </div>
      <hr>
      <!-- <div style="max-width: 450px; background: #506c85; padding: 30px;">
                 <TabsBlock :tabs="tabs" :initialTab="initialTab">
                   &lt;!&ndash;&ndash;&gt;
                   <template slot="tab-btn-1">Tab one</template>
                   <template slot="tab-item-1">
                     <div class="text">
                       <h3>Lorem ipsum dolor sit.</h3>
                       <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorum explicabo facere
                         inventore, nostrum rerum sunt? Distinctio iusto praesentium rem voluptatibus.</p>
                     </div>
                   </template>
                   &lt;!&ndash;&ndash;&gt;
                   <template slot="tab-btn-2">Tab twoo</template>
                   <template slot="tab-item-2">
                     <div class="text">
                       <h3>Lorem ipsum</h3>
                       <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorum explicabo facere
                         inventore, nostrum rerum sunt? Distinctio iusto praesentium rem voluptatibus.Dolorum
                         explicabo facere
                         inventore, nostrum rerum sunt?</p>
                     </div>
                   </template>
                   &lt;!&ndash;&ndash;&gt;
                 </TabsBlock>
       </div>
       <hr>
             <div style="max-width: 450px; background: white; padding: 30px;">
               <TabsBlock :tabs="tabs" :initialTab="initialTab" class="_white">
                 &lt;!&ndash;&ndash;&gt;
                 <template slot="tab-btn-1">Tab one</template>
                 <template slot="tab-item-1">
                   <div class="text">
                     <h3>Lorem ipsum dolor sit.</h3>
                     <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorum explicabo facere
                       inventore, nostrum rerum sunt? Distinctio iusto praesentium rem voluptatibus.</p>
                   </div>
                 </template>
                 &lt;!&ndash;&ndash;&gt;
                 <template slot="tab-btn-2">Tab twoo</template>
                 <template slot="tab-item-2">
                   <div class="text">
                     <h3>Lorem ipsum</h3>
                     <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorum explicabo facere
                       inventore, nostrum rerum sunt? Distinctio iusto praesentium rem voluptatibus.Dolorum
                       explicabo facere
                       inventore, nostrum rerum sunt?</p>
                   </div>
                 </template>
                 &lt;!&ndash;&ndash;&gt;
               </TabsBlock>
             </div>-->
      <hr>
      <div style="background: white; padding: 30px;">
        <BaseHelp value="Some text by props value"
                  width="30rem"
                  style="margin-right: 30rem"/>
        <BaseHelp style="margin-right:70rem">
          <div class="text">
            <p>Some content by slot</p>
          </div>
        </BaseHelp>
        <BaseHelp width="50rem">
          <div class="text">
            <p>Some content by slot</p>
          </div>
        </BaseHelp>
      </div>
      <hr>
      <div style="background: white; padding: 30px; display: flex; flex-wrap: wrap; justify-content: space-between">
        <TranslateFiled v-model="translateFiled"
                        title="Заголовок вакансии"
                        style="margin-bottom: 2rem; width: 46%"/>
        <TranslateFiled v-model="translateFiled"
                        label="Заголовок вакансии"
                        style="margin-bottom: 2rem; width: 46%"/>
        <TranslateFiled v-model="translateFiledEditor"
                        title="Заголовок вакансии"
                        editor
                        style="margin-bottom: 2rem; margin-top: 2rem; width: 46%"/>
      </div>
      <hr>
      <div style="background: white; padding: 30px; flex-wrap: wrap; justify-content: space-between">
        <code>
          type="checkbox" (default)
        </code>
        <ButtonCheckboxesList v-model="buttonCheckListValue"
                              :options="buttonCheckList"
                              style="margin-bottom: 3rem; width: 30rem"/>
        <code>
          type="radio"
        </code>
        <ButtonCheckboxesList v-model="buttonCheckListValue2"
                              type="radio"
                              :options="buttonCheckList2"
                              style="margin-bottom: 3rem; width: 30rem"/>
        <code>
          type="radio"<br>
          compare-type="id"
        </code>
        <ButtonCheckboxesList v-model="buttonCheckListValue3"
                              type="radio"
                              compare-type="id"
                              :options="buttonCheckList3"
                              style="margin-bottom: 3rem; width: 30rem"/>
      </div>
      <hr>
      <div style="background: white; padding: 30px; flex-wrap: wrap; justify-content: space-between">
        {{birthday && birthday.toLocaleString()}}
        <BirthdaySelect v-model="birthday"/>
      </div>
      <hr>
      <div style="background: white; padding: 30px; flex-wrap: wrap; justify-content: space-between">
        <DatePiker v-model="date"/>
      </div>
      <hr>
    </div>

  </div>
</template>

<script>
  import '../assets/less/style-account.less'
  //  import TabsBlock from "../components/TabsBlock";
  import TheSvgList from "../components/TheSvgList"
  import TranslateFiled from "../components/TranslateFiled"
  import ButtonCheckboxesList from "../components/ButtonCheckList"
  import BirthdaySelect from "../components/BirthdaySelect"
  import DatePiker from "../components/DatePiker"

  export default {
    components: {
      TheSvgList,
      TranslateFiled,
      ButtonCheckboxesList,
      BirthdaySelect,
      DatePiker,
      //    TabsBlock
    },
    data() {
      return {
        inputValue: 'input text',
        inputValueNumber: null,
        inputValueTime: null,
        isInputError: true,

        radioListValue: null,
        radioListValue2: '2',
        radioList: ['1', '2', '3'],

        selectValue: null,
        selectList: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],

        initialTab: '1',
        tabs: ['1', '2'],
        translateFiled: null,
        translateFiledEditor: null,


        buttonCheckListValue: null,
        buttonCheckListValue2: null,
        buttonCheckListValue3: null,
        buttonCheckList: [{
          id: 1,
          text: 'Name 1'
        }, {
          id: 2,
          text: 'Name 2'
        }],
        buttonCheckList2: [{
          id: 1,
          text: 'Name 21'
        }, {
          id: 2,
          text: 'Name 22'
        }],
        buttonCheckList3: [{
          id: 1,
          text: 'Name 31'
        }, {
          id: 2,
          text: 'Name 32'
        }],

        birthday: null,
        date: null,
      }
    }
  }
</script>

<style lang="less">
  .guide-block {
    .base-btn {
      margin: .5rem;
    }
  }

  .guide-svg {
    flex-wrap: wrap;

    svg {
      display: block;
      flex-shrink: 0;
      margin: 1rem;
      width: 3rem;
      height: 3rem;
    }
  }
</style>
